import React from 'react'
import { useInsightContentData } from 'hooks/useInsightModalState'
import { CountTypeStrings } from 'enums/CountType'
import { InsightContentSettingType } from 'components/insightContent/types'
import SparklineOverview from 'components/insightContent/visualization/Overview/SparklineOverview'
import { getMeasureTypeByCountType } from 'components/insightContent/utils/utils'
import { MetricTimeUnitStrings } from 'enums/MetricTimeUnit'
import InsightContentType from 'components/insightContent/enum/InsightContentType'
import UnexpectedErrorBoundary from 'components/UnexpectedErrorBoundary'
import RunSearchEffect from './RunSearchEffect'

const SharedTotalMeasure = ({
  detailSetting,
  countType,
  title,
  timeUnits,
  forceNotScale
}: {
  detailSetting: InsightContentSettingType
  countType: CountTypeStrings
  title: React.ReactNode
  timeUnits?: MetricTimeUnitStrings[]
  forceNotScale?: boolean
}) => {
  const insightContent = useInsightContentData(InsightContentType.TOTAL_MEASURE)

  return (
    <UnexpectedErrorBoundary>
      <RunSearchEffect
        detailSetting={detailSetting}
        countType={countType}
        timeUnits={timeUnits}
        forceNotScale={forceNotScale}>
        <SparklineOverview
          title={title}
          count={
            insightContent?.data?.[0]?.results?.[0]?.data?.metrics?.[0]?.dataset?.[0]?.set?.[0]
          }
          sparklineData={
            insightContent?.data?.[0]?.results?.[0]?.data?.metrics?.[1]?.dataset?.[0]?.set
          }
          measureType={getMeasureTypeByCountType(countType)}
          status={insightContent?.status}
        />
      </RunSearchEffect>
    </UnexpectedErrorBoundary>
  )
}

export default SharedTotalMeasure
